"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ItemTableCellWrapper = _styledComponents.default.div.withConfig({
  displayName: "ItemTableCell__ItemTableCellWrapper",
  componentId: "design-system__sc-1i5mpn4-0"
})(["a{text-decoration:none;color:", ";font-size:", ";display:inline-block;}.title-line{display:flex;align-items:center;.info{margin-left:", ";}svg{display:block;path{fill:", ";}}}.status{display:inline-block;font-size:", ";text-transform:uppercase;color:", ";margin-right:", ";}.children{font-size:", ";color:", ";display:inline-block;}"], _BaseTheme.default.colors.blue, _BaseTheme.default.type.size.normal, _BaseTheme.default.distance.small, _BaseTheme.default.colors.blue, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.gray, _BaseTheme.default.distance.small, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.lightgray);

const ItemTableCell = _ref => {
  let {
    title,
    url,
    status,
    info,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(ItemTableCellWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "title-line"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: url
  }, title), !!info && /*#__PURE__*/_react.default.createElement("div", {
    className: "info",
    "data-tip": info
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "16",
    type: "info"
  }), /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
    effect: "solid"
  }))), (!!status || !!children) && /*#__PURE__*/_react.default.createElement("span", null, !!status && /*#__PURE__*/_react.default.createElement("span", {
    className: "status"
  }, status), !!children && /*#__PURE__*/_react.default.createElement("span", {
    className: "children"
  }, children)));
};

ItemTableCell.propTypes = {
  title: _propTypes.default.string.isRequired,
  url: _propTypes.default.string,
  status: _propTypes.default.string,
  info: _propTypes.default.string,
  children: _propTypes.default.element
};
ItemTableCell.defaultProps = {
  url: '',
  status: '',
  info: '',
  children: undefined
};
var _default = ItemTableCell;
exports.default = _default;